import { Main } from './components/containers/Main';

export const CourierFileView = () => {
    return <Main />;
};
